var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d-container',{attrs:{"fluid":""}},[_c('main',{staticClass:"main-login-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }